export default __webpack_public_path__ + "static/media/abstract2.0bd3e4ab.svg";